import React, { Component } from "react";
import { Col, Row, Form, Alert, Button, Input } from "antd";
import { history, Loader, strings } from "../../helpers";
import NumericInput from "../../helpers/NumericInput";

const FormItem = Form.Item;

class LoginView extends Component {
  goToDashboard = () => {
    history.push("/dashboard");
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      handleChange,
      handleSubmit,
      isProcessing,
      error,
      errorMsg,
      serverErrorText,
      serverError,
      password,
      phoneNumber
    } = this.props;

    return (
      <div className="auth-form">
        {isProcessing && <Loader />}
        <div className="auth-form">
          <Row
            type="flex"
            justify="center"
            align="middle"
            className="auth-form-row"
          >
            <Col xs={24} md={12} sm={16} lg={8}>
              <div className="login-form-wrapper">
                <h2 className="login-title text-center">
                  {" "}
                  {strings.signin.signInText}
                </h2>
                <h4 className="login-sub-title text-center">
                  {strings.signin.signInHeadingText}
                </h4>
                <div className="form-alerts-wrapper">
                  {error && (
                    <Alert message={strings[errorMsg]} type="error" showIcon />
                  )}

                  {serverError && (
                    <Alert
                      message={strings[serverErrorText]}
                      type="error"
                      showIcon
                    />
                  )}
                </div>

                <Form onSubmit={handleSubmit} className="login-form">
                  <FormItem>
                    {getFieldDecorator("phoneNumber", {
                      initialValue: `${phoneNumber}`,
                      rules: [
                        {
                          required: true,
                          message: `${strings.signin.enterPhoneNumber}`
                        }
                      ]
                    })(
                      <NumericInput
                        name="phoneNumber"
                        onChange={handleChange}
                        placeholder={strings.tickets.phone_number}
                        maxLength={10}
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator("password", {
                      initialValue: `${password}`,
                      rules: [
                        {
                          required: true,
                          message: `${strings.signin.passwordRequired}`
                        }
                      ]
                    })(
                      <Input
                        type="password"
                        placeholder={strings.signin.password}
                        name="password"
                        onChange={handleChange}
                      />
                    )}
                  </FormItem>

                  <FormItem>
                    <Row type="flex" justify="start" align="middle">
                      <Col span={24}>
                        <Button
                          // disabled={buttonDisabled}
                          loading={isProcessing}
                          type="primary"
                          htmlType="submit"
                          className="login-form-button"
                        >
                          {strings.signin.signInText}
                        </Button>
                      </Col>
                    </Row>
                  </FormItem>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Form.create()(LoginView);
